import React, { useState } from "react";
import { ChevronDown, Trophy } from "lucide-react";
import { Button } from "./ui/button";
import { formatUSD } from "../mock";

const LeaderboardTable = ({ rows }) => {
  const [showAll, setShowAll] = useState(false);
  const visible = showAll ? rows : rows.slice(0, 10);

  return (
    <div className="max-w-4xl mx-auto w-full">
      <div className="rounded-2xl glass overflow-hidden">
        {/* header */}
        <div className="grid grid-cols-12 gap-2 px-3 sm:px-5 py-4 border-b border-emerald-500/10 text-[10px] sm:text-[11px] uppercase tracking-widest text-slate-500">
          <div className="col-span-2">Rank</div>
          <div className="col-span-4">Player</div>
          <div className="col-span-3 text-right">Wagered</div>
          <div className="col-span-3 text-right">Prize</div>
        </div>

        <div className="divide-y divide-white/5">
          {visible.map((r) => (
            <div
              key={r.rank}
              data-testid={`leaderboard-row-${r.rank}`}
              className="lb-row grid grid-cols-12 gap-2 items-center px-3 sm:px-5 py-3.5"
            >
              <div className="col-span-2">
                <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-white/5 ring-1 ring-white/10 text-sm font-semibold text-slate-300 tabular-nums">
                  {r.rank}
                </span>
              </div>
              <div data-testid={`leaderboard-player-${r.rank}`} className="col-span-4 font-medium text-white truncate text-sm sm:text-base">
                {r.user}
              </div>
              <div data-testid={`leaderboard-wagered-${r.rank}`} className="col-span-3 min-w-0 break-words text-right text-slate-300 tabular-nums text-sm sm:text-base">
                {formatUSD(r.wagered)}
              </div>
              <div data-testid={`leaderboard-prize-${r.rank}`} className="col-span-3 text-right">
                <span className="inline-flex max-w-full items-center gap-1 text-emerald-300 font-semibold tabular-nums text-sm sm:text-base">
                  <Trophy className="h-3.5 w-3.5 shrink-0 hidden sm:block" />
                  <span className="min-w-0 break-all">{formatUSD(r.prize)}</span>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {rows.length > 10 && (
        <div className="flex justify-center mt-6">
          <Button
            variant="outline"
            onClick={() => setShowAll((s) => !s)}
            data-testid="leaderboard-toggle-more"
            className="border-emerald-500/30 bg-white/5 text-emerald-200 hover:bg-emerald-500/10 hover:text-white group"
          >
            {showAll ? "Show Less" : "Reveal More"}
            <ChevronDown
              className={`ml-2 h-4 w-4 transition-transform ${
                showAll ? "rotate-180" : ""
              }`}
            />
          </Button>
        </div>
      )}
    </div>
  );
};

export default LeaderboardTable;
